import { Button, ButtonGroup, Dialog, DialogContent, Divider, Grid, Menu, MenuItem, MenuList, Stack, Typography, buttonGroupClasses, useMediaQuery } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { AddIcon, ChevronDownIcon, DashboardSearchIcon } from '../../assets/customIcons';
import { ArrowDownIconNew, CalenderIconBlack, FilterButtonNew } from '../../assets/images';
import { EUserRole, LOCAL_STORAGE_KEYS, Module, ModuleName, dateBeforeWeek, headerTitle, isModuleConfig } from '../../constants';
import { setIsAllViewActive } from '../../redux/commonSlice';
import { setReducerState } from '../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { systemColor } from '../../theme/systemColor';
import { getLocalStorageItem } from '../../utils/storageHelper';
import useAnalyticsEventTracker from '../../utils/useAnalyticsEventTracker';
import { formDateFormate, maxDays } from '../../utils/utils';
import { MuiButton } from '../atoms/buttonComponent';
import { MuiIconButton } from '../atoms/iconButtonComponent';
import { MuiStack } from '../atoms/stackComponent';
import ToggleIconButtonComponent from '../atoms/toggleIconButtonComponent';
import DashboardSearch from './search/dashboardSearch';
import ModuleSearch from './search/moduleSearch';
import { secondary } from '../../theme/colors';
var newTheme = createTheme({
    components: {
        MuiPickersCalendarHeader: {
            styleOverrides: {
                root: {
                    // Style for the selected day
                    '&.Mui-selected': {
                        backgroundColor: "".concat(systemColor.primary, " !important"),
                        // Change this to the desired color
                        color: 'white' // Optional: Text color for better contrast
                    },
                    // Optional: Hover state for the selected day
                    '&.Mui-selected:hover': {
                        backgroundColor: '#1B1D21' // Change this to the hover color
                    }
                },
                label: {
                    fontSize: '16px',
                    color: '#1B1D21',
                    fontWeight: '500',
                    fontFamily: 'NotoSans-Regular'
                }
            }
        },
        MuiDayCalendar: {
            styleOverrides: {
                root: {
                    // Style for the selected day
                    '&.Mui-selected': {
                        backgroundColor: systemColor.primary,
                        // Change this to the desired color
                        color: 'white' // Optional: Text color for better contrast
                    },
                    // Optional: Hover state for the selected day
                    '&.Mui-selected:hover': {
                        backgroundColor: '#1B1D21' // Change this to the hover color
                    }
                },
                weekDayLabel: {
                    fontSize: '14px',
                    fontWeight: '400',
                    color: systemColor.primary,
                    fontFamily: 'NotoSans-Regular'
                }
            }
        },
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    // Style for the selected day
                    '&.Mui-selected': {
                        backgroundColor: systemColor.primary,
                        // Change this to the desired color
                        color: 'white' // Optional: Text color for better contrast
                    },
                    // Optional: Hover state for the selected day
                    '&.Mui-selected:hover': {
                        backgroundColor: '#1B1D21' // Change this to the hover color
                    }
                },
                // today: {
                //     backgroundColor: '#F4F7FA',
                //     border: '1px solid #F4F7FA',
                //     borderColor: '#F4F7FA'
                // },
                selected: {
                    '&.Mui-selected': {
                        backgroundColor: systemColor.primary,
                        // Change this to the desired color
                        color: 'white' // Optional: Adjust text color
                    }
                },
                dayWithMargin: {
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#1B1D21',
                    fontFamily: 'NotoSans-Regular'
                }
            }
        }
    }
});
var HeaderCatalogPageComponent = function (props) {
    var _a;
    var _getLocalStorageItem, _getLocalStorageItem2;
    var handleClickFilterIcon = props.handleClickFilterIcon, selectedMenuItem = props.selectedMenuItem, menus = props.menus, onSelectMenu = props.onSelectMenu, isFromDashboard = props.isFromDashboard, onCalendarFilterApply = props.onCalendarFilterApply, isFromNewDashboard = props.isFromNewDashboard, activeView = props.activeView, onToggleView = props.onToggleView, isDashboard = props.isDashboard, totalCount = props.totalCount, onClickCreateModule = props.onClickCreateModule, createButtonText = props.createButtonText, isCreateButton = props.isCreateButton, moduleName = props.moduleName, title = props.title, addButtonDropdown = props.addButtonDropdown, onDropDownClick = props.onDropDownClick, _b = props.addButtonText, addButtonText = _b === void 0 ? 'New' : _b, onButtonClick = props.onButtonClick, pagingKey = props.pagingKey, _c = props.isTotalCount, isTotalCount = _c === void 0 ? true : _c;
    var trackButtonClick = useAnalyticsEventTracker("ListPageHeaderComponent");
    var localFromDate = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_FROM_DATE)) !== null && _getLocalStorageItem !== void 0 ? _getLocalStorageItem : formDateFormate(dateBeforeWeek);
    var localToDate = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_TO_DATE)) !== null && _getLocalStorageItem2 !== void 0 ? _getLocalStorageItem2 : formDateFormate(dayjs());
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var upSM = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dowMd = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var inspection = useParams().inspection;
    var dispatch = useAppDispatch();
    var location = useLocation();
    var IS_MOBILE = upXS && downSM;
    var IS_TABLET = upSM && dowMd;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var _d = useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var _e = useState(false), openCalendarFilter = _e[0], setOpenCaledarFilter = _e[1];
    var _f = useState(false), isFromDateCalOpen = _f[0], setIsFromDateCalOpen = _f[1];
    var _g = useState(false), isToDateCalOpen = _g[0], setIsToateCalOpen = _g[1];
    var _h = useState(""), pageTitle = _h[0], setPageTitle = _h[1];
    var _j = useState(false), isSearchActive = _j[0], setIsSearchActive = _j[1];
    var _k = useState(localFromDate), fromDate = _k[0], setFromDate = _k[1];
    var _l = useState(localToDate), toDate = _l[0], setToDate = _l[1];
    var open = Boolean(anchorEl);
    var selectedDesignationStorage = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var MaxDateRange = getLocalStorageItem(LOCAL_STORAGE_KEYS.DATE_FILTER_RESTRICTION);
    console.log("IsTotal Count ", isTotalCount);
    function getPageTitle() {
        var path = window.location.pathname.substring(1).toLowerCase();
        var selectedMenuItem = '';
        var title = headerTitle.some(function (menu) {
            var lowercasePaths = menu.paths.map(function (p) { return p.toLowerCase(); });
            if (lowercasePaths.some(function (p) { return path.startsWith(p); })) {
                selectedMenuItem = menu.section;
                return true;
            }
            return false;
        });
        if (Module === isModuleConfig.Bajaj && inspection) {
            setPageTitle("HEADER_TITLE_VI");
            return 'HEADER_TITLE_VI';
        }
        else {
            setPageTitle(title ? selectedMenuItem : '');
            return title ? selectedMenuItem : '';
        }
    }
    useEffect(function () {
        getPageTitle();
    }, [location]);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
        dispatch(setReducerState({
            key: 'filterValue',
            value: null
        }));
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var openFromDateCalendar = function () {
        setIsFromDateCalOpen(true);
        setIsToateCalOpen(false);
    };
    var openToDateCalendar = function () {
        setIsToateCalOpen(true);
        setIsFromDateCalOpen(false);
    };
    var onFromDateCalendarClick = function (newValue) {
        var date = formDateFormate(newValue);
        setFromDate(date);
        setToDate("");
    };
    var onToDateCalendarClick = function (newValue) {
        var date = formDateFormate(newValue);
        setToDate(date);
    };
    var onResetClick = function () {
        setFromDate('');
        setToDate('');
    };
    var onApplyClick = function () {
        setOpenCaledarFilter(false);
        setIsFromDateCalOpen(false);
        setIsToateCalOpen(false);
        var fromCalDate = fromDate !== null && fromDate !== void 0 ? fromDate : formDateFormate(dateBeforeWeek);
        var toCalDate = toDate !== null && toDate !== void 0 ? toDate : formDateFormate(dayjs());
        onCalendarFilterApply(fromCalDate, toCalDate);
    };
    var onCancelClick = function () {
        setFromDate(localFromDate !== null && localFromDate !== void 0 ? localFromDate : formDateFormate(dateBeforeWeek));
        setToDate(localToDate !== null && localToDate !== void 0 ? localToDate : formDateFormate(dayjs()));
        setOpenCaledarFilter(false);
        setIsFromDateCalOpen(false);
        setIsToateCalOpen(false);
    };
    var DashboardMenuArray = ['My View', 'All View'];
    var _m = useState(true), myView = _m[0], setMyView = _m[1];
    var _o = useState(false), allView = _o[0], setAllView = _o[1];
    var _p = useState(DashboardMenuArray[0]), selectedView = _p[0], setSelectedView = _p[1];
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    useEffect(function () {
        if (isAllViewActive) {
            setAllView(true);
            setMyView(false);
        }
    }, []);
    var selectView = function (item) {
        setAllView(!allView);
        dispatch(setIsAllViewActive(item === 'My View' ? false : true));
        setMyView(!myView);
        setSelectedView(item);
    };
    var selectViewContentMobile = /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%'
    }, pageTitle !== ModuleName.Dashboard ? /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: 'space-between',
        sx: {
            alignItems: 'center'
        }
    }, menus ? /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: '16px'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        alignItems: 'center',
        width: '100%',
        px: '16px'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "select-moodule-type",
        name: selectedMenuItem ? t(selectedMenuItem) : '',
        variant: "text",
        endIcon: /*#__PURE__*/ React.createElement("img", {
            id: "dropdownIcon",
            src: ArrowDownIconNew,
            alt: "dropdown"
        }),
        sx: {
            fontWeight: 600,
            fontSize: 16,
            color: '#1B1D21',
            bgcolor: '#F4F7FA',
            fontFamily: 'NotoSans-Medium',
            textTransform: "none"
        },
        onClick: handleClick
    }), isTotalCount ? /*#__PURE__*/ React.createElement(MuiStack, {
        px: 1.5,
        py: 0.5,
        border: '1px solid #AFD5FF',
        borderRadius: '20px',
        bgcolor: '#EEF6FF'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            whiteSpace: 'nowrap',
            color: systemColor.borderColor
        }
    }, totalCount || 1234)) : null), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        gap: '16px',
        alignItems: 'center',
        margin: 0,
        display: 'flex',
        bgcolor: '#EFF2F5',
        padding: '16px',
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#DEE4EB'
    }, /*#__PURE__*/ React.createElement(ModuleSearch, null), IS_MOBILE && /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'flex-end'
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        sx: {
            border: '1px solid #DEE4EB',
            bgcolor: '#FFFFFF',
            height: "36px",
            width: '36px',
            borderRadius: '8px'
        }
        //    onClick={() => setOpenFilter((prev) => !prev)}
        ,
        onClick: function () {
            handleClickFilterIcon();
            trackButtonClick("ButtonClickEvent", "Mobile_Filter_Open", undefined);
        },
        id: "filterButtonId"
    }, /*#__PURE__*/ React.createElement("img", {
        src: FilterButtonNew,
        id: "filterIcon",
        height: '36px',
        width: '36px',
        alt: "settingIcon"
    }))))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1",
        sx: {
            whiteSpace: 'nowrap'
        }
    }, pageTitle ? t(pageTitle) : title), /*#__PURE__*/ React.createElement(MuiStack, {
        p: 1,
        border: '1px solid #AFD5FF',
        borderRadius: '10px',
        bgcolor: '#EEF6FF'
    }, totalCount || 0)), /*#__PURE__*/ React.createElement(Menu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        disableScrollLock: true,
        MenuListProps: {
            'aria-labelledby': 'basic-button',
            sx: {
                padding: 0,
                whiteSpace: 'nowrap'
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: '8px',
                    border: '1px solid #DEE4EB'
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '200px'
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: '100%',
            padding: 0,
            whiteSpace: 'nowrap'
        }
    }, menus && (menus === null || menus === void 0 ? void 0 : menus.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: "menu-item ".concat(index),
            dense: true,
            key: index,
            sx: {
                width: '100%',
                height: '42px',
                borderBottom: index === menus.length - 1 ? "none" : '1px solid #DEE4EB',
                fontWeight: 500,
                fontSize: 14,
                fontFamily: 'NotoSans-Medium',
                textTransform: 'capitalize'
                // whiteSpace:'nowrap'
            },
            onClick: function () {
                if (onSelectMenu) {
                    trackButtonClick("ButtonClickEvent", "Mobile_Menu_Select_" + "".concat(item), undefined);
                    onSelectMenu(item);
                    dispatch(setReducerState({
                        key: pagingKey + 'Updated',
                        value: true
                    }));
                    onResetClick();
                    handleClose();
                }
            }
        }, t(item));
    })))))) : /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            alignItems: 'center',
            paddingTop: 0.5
        }
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "select-moodule-type",
        name: selectedView,
        variant: "text",
        endIcon: /*#__PURE__*/ React.createElement("img", {
            id: "dropdownIcon",
            src: ArrowDownIconNew,
            alt: "dropdown"
        }),
        sx: {
            fontWeight: 600,
            fontSize: 16,
            color: '#1B1D21',
            bgcolor: '#F4F7FA',
            fontFamily: 'NotoSans-Medium',
            textTransform: "none"
        },
        onClick: handleClick
    })), /*#__PURE__*/ React.createElement(Menu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        disableScrollLock: true,
        MenuListProps: {
            'aria-labelledby': 'basic-button',
            sx: {
                padding: 0,
                whiteSpace: 'nowrap'
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: '8px',
                    border: '1px solid #DEE4EB'
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '200px'
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: '100%',
            padding: 0,
            whiteSpace: 'nowrap'
        }
    }, DashboardMenuArray && (DashboardMenuArray === null || DashboardMenuArray === void 0 ? void 0 : DashboardMenuArray.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: "menu-item ".concat(index),
            dense: true,
            key: index,
            sx: {
                width: '100%',
                height: '42px',
                borderBottom: index === DashboardMenuArray.length - 1 ? "none" : '1px solid #DEE4EB',
                fontWeight: 500,
                fontSize: 14,
                fontFamily: 'NotoSans-Medium',
                textTransform: 'capitalize'
                // whiteSpace:'nowrap'
            },
            onClick: function () {
                trackButtonClick("ButtonClickEvent", "Mobile_Menu_Select_" + "".concat(item), undefined);
                selectView(item);
                handleClose();
            }
        }, t(item));
    })))))));
    var selectViewContentDesktop = /*#__PURE__*/ React.createElement(MuiStack, {
        padding: '14px 24px'
    }, menus && /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            alignItems: 'center'
        },
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        id: "select-moodule-type",
        name: selectedMenuItem ? t(selectedMenuItem) : '',
        variant: "text",
        endIcon: /*#__PURE__*/ React.createElement("img", {
            id: "dropdownIcon",
            src: ArrowDownIconNew,
            alt: "dropdown"
        }),
        sx: {
            fontWeight: 'strong',
            fontSize: 'xxl',
            color: '#1B1D21',
            bgcolor: '#F4F7FA',
            textTransform: "none",
            padding: 0
        },
        onClick: handleClick
    }), isTotalCount ? /*#__PURE__*/ React.createElement(MuiStack, {
        px: 1.5,
        py: 0.5,
        border: '1px solid #AFD5FF',
        borderRadius: '20px',
        bgcolor: '#EEF6FF'
    }, pageTitle !== null && pageTitle !== void 0 && pageTitle.includes('Appointment') ? /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            whiteSpace: 'nowrap',
            color: systemColor.borderColor
        }
    }, "".concat(totalCount || 0, " Appointments")) : /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            whiteSpace: 'nowrap',
            color: systemColor.borderColor
        }
    }, totalCount || 0)) : null, /*#__PURE__*/ React.createElement(Menu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        disableScrollLock: true,
        MenuListProps: {
            'aria-labelledby': 'basic-button',
            sx: {
                padding: 0,
                whiteSpace: 'nowrap'
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: '8px',
                    border: '1px solid #DEE4EB'
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: '100%',
            padding: 0,
            whiteSpace: 'nowrap'
        }
    }, menus && (menus === null || menus === void 0 ? void 0 : menus.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: "menu-item ".concat(index),
            dense: true,
            key: index,
            sx: {
                width: '100%',
                height: '42px',
                borderBottom: index === menus.length - 1 ? "none" : '1px solid #DEE4EB',
                fontWeight: '500',
                fontSize: '14px',
                fontFamily: 'NotoSans-Medium',
                textTransform: 'capitalize',
                color: '#6A7682'
                // whiteSpace:'nowrap'
            },
            onClick: function () {
                if (onSelectMenu) {
                    trackButtonClick("ButtonClickEvent", "Desktop_Menu_Select_" + "".concat(item), undefined);
                    onSelectMenu(item);
                    dispatch(setReducerState({
                        key: pagingKey + 'Updated',
                        value: true
                    }));
                    onResetClick();
                    handleClose();
                }
            }
        }, t(item));
    })))))));
    var showMyViewAllView = function () {
        if (IS_MOBILE) {
            if ((selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) === EUserRole.FinalInspector && isFromNewDashboard) {
                return false;
            }
            else {
                return true;
            }
        }
        if (IS_TABLET) {
            if ((selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) === EUserRole.ServiceAdvisor && isFromNewDashboard) {
                return true;
            }
            else {
                return false;
            }
        }
        if (IS_DESKTOP) {
            return false;
        }
        return false;
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        sx: {
            py: {
                xs: '16px',
                sm: 0,
                md: 0,
                lg: 0
            }
        }
    }, showMyViewAllView() ? /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        alignItems: 'center',
        sx: {
            height: {
                xs: '108px',
                sm: '44px',
                md: '44px',
                lg: '44px'
            }
        },
        bgcolor: '#F4F7FA'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        width: '100%'
    }, selectViewContentMobile)) : /*#__PURE__*/ React.createElement(React.Fragment, null), isFromNewDashboard && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2,
        bgcolor: '#EFF2F5',
        marginLeft: '-16px !important',
        marginRight: '-16px !important'
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            border: '1px solid #DEE4EB',
            marginLeft: '-16px'
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        px: 2,
        justifyContent: 'space-between',
        alignItems: "center",
        gap: 0.5,
        sx: {
            placeItems: 'center'
        }
    }, !isSearchActive && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        alignItems: 'start'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5",
        color: '#8593A3'
    }, t("Viewing stats for")), /*#__PURE__*/ React.createElement(Typography, null, localFromDate != null ? formDateFormate(localFromDate) : formDateFormate(dateBeforeWeek), " - ", localToDate != null ? formDateFormate(localToDate) : formDateFormate(dayjs()))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'end',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        id: "search-container",
        border: '1px solid #DEE4EB',
        p: 1.2,
        borderRadius: 2,
        bgcolor: systemColor.white,
        sx: {
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        id: "calander-icon",
        alt: "calander",
        style: {
            height: '20px',
            width: '20px'
        },
        src: CalenderIconBlack,
        onClick: function () {
            setOpenCaledarFilter(true);
            setIsFromDateCalOpen(true);
        }
    })), !isSearchActive && /*#__PURE__*/ React.createElement(MuiStack, {
        border: '1px solid #DEE4EB',
        p: 1.2,
        borderRadius: 2,
        bgcolor: systemColor.white,
        sx: {
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ React.createElement(DashboardSearchIcon, {
        stroke: "#8593A3",
        width: "20px",
        height: "20px",
        fontWeight: "700",
        onClick: function () { return setIsSearchActive(true); }
    }))), isSearchActive && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DashboardSearch, {
        request: {
            FromDate: fromDate ? new Date(fromDate).toISOString() : dateBeforeWeek.toISOString(),
            ToDate: toDate ? new Date(toDate).toISOString() : dayjs().toISOString()
        },
        isSearchActive: isSearchActive
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        name: "Cancel",
        variant: "text",
        sx: {
            background: 'none',
            ml: '3px'
        },
        onClick: function () { return setIsSearchActive(false); }
    }))), /*#__PURE__*/ React.createElement("div", {
        style: {
            border: '1px solid #DEE4EB',
            marginLeft: '-16px'
        }
    })), openCalendarFilter &&
        /*#__PURE__*/
        // <Dialog open={openCalendarFilter} onClose={() => { setOpenCaledarFilter(false); setIsFromDateCalOpen(false); setIsToateCalOpen(false) }} fullWidth style={{ background: 'none', width: '100%', height: '100%' }}>
        React.createElement(Dialog, {
            open: openCalendarFilter,
            onClose: function () { return onCancelClick(); },
            fullWidth: true,
            style: {
                background: 'none',
                width: '100%',
                height: '100%'
            }
        }, /*#__PURE__*/ React.createElement(DialogContent, {
            style: {
                padding: 0,
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column'
            }
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            justifyContent: "space-between",
            sx: {
                padding: '20px 30px 0px 30px'
            }
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Button, {
            sx: {
                width: '100%',
                padding: '8px 8px',
                marginTop: '8px',
                borderRadius: '8px',
                border: '1px solid #DEE4EB',
                boxShadow: '0px 1px 5px 0px rgba(16, 24, 40, 0.05)',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                borderColor: isFromDateCalOpen ? '#1B1D21' : '#DEE4EB'
            },
            onClick: function () { return openFromDateCalendar(); }
        }, /*#__PURE__*/ React.createElement("img", {
            src: CalenderIconBlack,
            alt: "calander"
        }), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            id: "calander-icon",
            sx: {
                marginLeft: '2px',
                color: '#1B1D21',
                opacity: fromDate ? 1 : 0.5
            }
        }, fromDate || 'From date'))), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(Button, {
            sx: {
                width: '100%',
                padding: '8px 8px',
                marginTop: '8px',
                borderRadius: '8px',
                border: '1px solid red',
                boxShadow: '0px 1px 5px 0px rgba(16, 24, 40, 0.05)',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                borderColor: isToDateCalOpen ? '#1B1D21' : '#DEE4EB',
                opacity: !fromDate ? 0.5 : 1
            },
            onClick: function () { return openToDateCalendar(); },
            disabled: !fromDate
        }, /*#__PURE__*/ React.createElement("img", {
            src: CalenderIconBlack,
            alt: "calander",
            id: "calander-icon"
        }), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            sx: {
                marginLeft: '2px',
                color: '#1B1D21',
                opacity: toDate ? 1 : 0.5
            }
        }, toDate || 'To date')))), isFromDateCalOpen && isFromNewDashboard && /*#__PURE__*/ React.createElement(LocalizationProvider, {
            dateAdapter: AdapterDayjs
            //localeText={{ cancelButtonLabel: 'Cancel', okButtonLabel: 'Apply' }}
        }, /*#__PURE__*/ React.createElement(DemoContainer, {
            components: ['StaticDatePicker']
        }, /*#__PURE__*/ React.createElement(DemoItem, null, /*#__PURE__*/ React.createElement(ThemeProvider, {
            theme: newTheme
        }, /*#__PURE__*/ React.createElement(StaticDatePicker, {
            value: dayjs(fromDate)
            //format="MMM DD, YYYY"
            ,
            onChange: function (value) { return onFromDateCalendarClick(value); },
            slots: {
                toolbar: undefined,
                switchViewIcon: undefined
            },
            onClose: function () {
                setOpenCaledarFilter(false);
                setIsFromDateCalOpen(false);
                setIsToateCalOpen(false);
            },
            slotProps: {
                actionBar: {
                    actions: []
                }
            },
            onAccept: function (value) { return console.log(value); }
            // minDate={dayjs(new Date).subtract(30, 'day')}
            // maxDate={dayjs(new Date)}
        }))))), isToDateCalOpen && isFromNewDashboard && /*#__PURE__*/ React.createElement(LocalizationProvider, {
            dateAdapter: AdapterDayjs
        }, /*#__PURE__*/ React.createElement(DemoContainer, {
            components: ['StaticDatePicker']
        }, /*#__PURE__*/ React.createElement(DemoItem, null, /*#__PURE__*/ React.createElement(ThemeProvider, {
            theme: newTheme
        }, /*#__PURE__*/ React.createElement(StaticDatePicker, {
            slots: {
                toolbar: undefined,
                switchViewIcon: undefined
            },
            value: dayjs(toDate),
            onChange: function (value) { return onToDateCalendarClick(value); },
            onClose: function () { return setOpenCaledarFilter(false); },
            slotProps: {
                actionBar: {
                    actions: []
                }
            },
            onAccept: function (value) { return console.log(value); }
            //minDate={dayjs(fromDate)}
            ,
            minDate: dayjs(fromDate),
            maxDate: dayjs(fromDate).add(MaxDateRange ? Number(MaxDateRange.Value) : maxDays, 'day')
        }))))), /*#__PURE__*/ React.createElement(Divider, {
            style: {
                width: '100%'
            }
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'row',
            marginTop: "16px",
            justifyContent: "space-between",
            alignItems: 'center',
            padding: "0px 20px 10px 10px"
        }, /*#__PURE__*/ React.createElement(Button, {
            sx: {
                fontSize: '14px',
                fontWeight: '500',
                padding: '10px 14px'
            },
            onClick: function () { return onResetClick(); }
        }, "Reset"), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiButton, {
            onClick: function () { return onCancelClick(); },
            name: t('Cancel'),
            size: "large",
            sx: {
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                padding: '10px 14px'
            }
        }), /*#__PURE__*/ React.createElement(MuiButton, {
            disabled: !(fromDate && toDate),
            onClick: function () { return onApplyClick(); },
            name: t('Apply'),
            size: "large",
            variant: "contained",
            sx: {
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                padding: '10px 14px',
                marginLeft: '8px',
                opacity: !(fromDate && toDate) ? 0.7 : 1
            }
        }))))), !IS_MOBILE && !isDashboard && /*#__PURE__*/ React.createElement(React.Fragment, null, selectViewContentDesktop, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        bgcolor: '#EFF2F5',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        padding: '16px 24px',
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: secondary[200]
    }, !isFromNewDashboard && /*#__PURE__*/ React.createElement(Stack, {
        alignItems: 'center',
        width: '320px',
        minHeight: '36px'
    }, /*#__PURE__*/ React.createElement(ModuleSearch, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'flex-end',
        spacing: 1.5,
        display: 'flex',
        width: '100%'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            border: '1px solid #DEE4EB',
            height: '44px',
            borderRadius: '8px',
            backgroundColor: '#EFF2F5',
            padding: '4px'
        }
    }, /*#__PURE__*/ React.createElement(ToggleIconButtonComponent, {
        activeView: activeView,
        onToggleView: function (value) {
            onToggleView(value);
            trackButtonClick("ButtonClickEvent", "Desktop_" + "".concat(value) + "_Click", undefined);
        },
        moduleName: moduleName
    })), IS_DESKTOP ? /*#__PURE__*/ React.createElement(MuiIconButton, {
        style: {
            border: '1px solid #DEE4EB',
            height: "44px",
            borderRadius: '8px',
            backgroundColor: 'white'
        },
        onClick: function () {
            handleClickFilterIcon();
            trackButtonClick("ButtonClickEvent", "Desktop_Filter_Open", undefined);
        },
        id: "filterButtonId"
    }, /*#__PURE__*/ React.createElement("img", {
        src: FilterButtonNew,
        id: "filterIcon",
        alt: "settingIcon",
        style: {
            marginLeft: "-10px",
            marginRight: "-5px"
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            whiteSpace: 'nowrap',
            color: '#6A7682'
        },
        id: "more-filter"
    }, "More Filter")) : /*#__PURE__*/ React.createElement(MuiIconButton, {
        sx: {
            border: '1px solid #DEE4EB',
            bgcolor: '#FFFFFF',
            height: "44px",
            width: '36px',
            borderRadius: '8px'
        }
        //    onClick={() => setOpenFilter((prev) => !prev)}
        ,
        onClick: function () {
            handleClickFilterIcon();
            trackButtonClick("ButtonClickEvent", "Mobile_Filter_Open", undefined);
        },
        id: "filterButtonId"
    }, /*#__PURE__*/ React.createElement("img", {
        src: FilterButtonNew,
        id: "filterIcon",
        height: '36px',
        width: '36px',
        alt: "settingIcon"
    })), isCreateButton && /*#__PURE__*/ React.createElement(Divider, {
        orientation: "vertical",
        flexItem: true
    }), isCreateButton && /*#__PURE__*/ React.createElement(MuiStack, null, addButtonDropdown ? /*#__PURE__*/ React.createElement(ButtonGroup, {
        variant: "contained",
        size: "medium",
        disableElevation: true,
        sx: (_a = {
                height: 44,
                columnGap: '1px'
            },
            _a["& .".concat(buttonGroupClasses.firstButton)] = {
                borderRight: 'none'
            },
            _a)
    }, /*#__PURE__*/ React.createElement(Button, {
        id: addButtonText + '-button',
        startIcon: /*#__PURE__*/ React.createElement(AddIcon, null),
        onClick: onButtonClick,
        sx: {
            height: 'inherit',
            typography: 'h5'
        }
    }, addButtonText), /*#__PURE__*/ React.createElement(Button, {
        id: addButtonText + '-menu',
        onClick: onDropDownClick,
        sx: {
            height: 'inherit'
        }
    }, /*#__PURE__*/ React.createElement(ChevronDownIcon, null))) : /*#__PURE__*/ React.createElement(MuiButton, {
        size: "large",
        color: "primary",
        id: "createAppointmentButton",
        onClick: function () {
            onClickCreateModule();
            trackButtonClick("ButtonClickEvent", "".concat(createButtonText) + " click", undefined);
        },
        name: createButtonText,
        variant: "contained",
        fullWidth: true
    })))))), isFromDashboard && /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "block"
        }
    }, /*#__PURE__*/ React.createElement(Typography, null, localFromDate != null ? formDateFormate(localFromDate) : formDateFormate(new Date()), " - ", localToDate != null ? formDateFormate(localToDate) : formDateFormate(new Date()))));
};
export default HeaderCatalogPageComponent;
